{
  "title": "Notification Emails and the Send Record",
  "description": "An overview of the emails your actions send (manual sends and side-effect notifications), where the footer contact email comes from, and how to check send results in the audit log.",
  "headings": [
    "What You'll Accomplish",
    "Applies To",
    "Before You Start",
    "Steps",
    "What You'll See",
    "FAQ"
  ],
  "summary": "So you know which actions email whom, and how to confirm they were sent.",
  "roleNote": "Organizer",
  "prerequisites": ["A contact email is filled in on the competition settings"],
  "pathLabel": "Competition management → Overview → Settings; Competition management → Audit log",
  "steps": [
    {
      "title": "1. Emails you send manually",
      "description": "Announcement emails, reminders for registrations that need an update, and registration reminders to team leaders (Team management page). All three show a count confirmation and an email preview before sending, so what you see is what is sent. Announcements and update reminders also offer \"Send a test email to me\"."
    },
    {
      "title": "2. Notifications triggered by your actions",
      "description": "Advancing teams to the finals (notifies the members of advancing teams, not teachers), returning a submission for revision (notifies that team's members), an eligibility proof marked not passed (notifies that student with the reason), and inviting or re-sending a judge invitation (notifies the judge; a new account gets one-time temporary sign-in details). These are sent automatically when you do the action, and the action screen tells you beforehand."
    },
    {
      "title": "3. The contact email in the footer",
      "description": "Reminder and announcement emails end with the competition's contact email from the settings (maintained on the Overview page's Settings card, shown as \"Organizer contact email\"); when it is empty, the line is omitted. The long \"Organizer contact information\" text is for website pages only and is never put in emails."
    }
  ],
  "afterward": [
    "Every send leaves a summary in the audit log with success and failure counts, without email addresses",
    "A failed email does not fail the original action, and the screen does not show failure counts live; check the audit log",
    "A sent email cannot be recalled"
  ],
  "nextSteps": "For announcements see \"How to Publish an Announcement and Email It\"; for reminders see \"Registrations That Need an Update, and Reminder Emails\".",
  "faq": [
    {
      "q": "Where can I see whether an email was sent?",
      "a": "In the competition's audit log, look for the notification email delivery entries, which show success and failure counts. If a judge invitation failed, use \"Resend\" on the invitation list."
    },
    {
      "q": "How do I change the footer contact email?",
      "a": "Edit \"Contact email\" on the Overview page's Settings card; emails sent afterward use the new value, and already sent emails are not updated."
    },
    {
      "q": "Do returning for revision and unlocking both send emails?",
      "a": "Returning for revision emails that team's members; unlocking does not send an email."
    }
  ]
}
